import { render } from "./detail-report-sub-money.vue?vue&type=template&id=1c87592a"
import script from "./detail-report-sub-money.vue?vue&type=script&lang=js"
export * from "./detail-report-sub-money.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__